const _INITIAL_STATE = {
    signature: "",
    sessionToken: "",
    transaction: {},
    callbackUrl: "",
    callbackMsg: "",
    isCallback: false
};

export const _TXN_KEY = {
    SIGNATURE: 'Signature',
    SESSION_TOKEN: "SessionToken",
    TRANSACTION_DETAIL: 'TransactionDetail',
    URL_DETAIL: "UrlDetail",
    BEARER: 'Bearer',
    CALLBACK: "Callback",
    CLEAR_CALLBACK: "ClearCallback"
};

/// <summary>
/// Author: YJ
/// </summary>
export default (state = _INITIAL_STATE, action) => {
    switch (action.type) {
        case _TXN_KEY['SIGNATURE']:
            return {
                ...state,
                signature: action.signature
            }
            break;
        case _TXN_KEY['SESSION_TOKEN']:
            return {
                ...state,
                sessionToken: action.sessionToken
            }
            break;
        case _TXN_KEY['TRANSACTION_DETAIL']:
            return {
                ...state,
                transaction: action.transaction,
                sessionToken: action.sessionToken
            }
            break;
        case _TXN_KEY['CALLBACK']:
            return {
                ...state,
                callbackUrl: action.callbackUrl,
                callbackMsg: action.callbackMsg,
                isCallback: true
            }
            break;
        case _TXN_KEY['CLEAR_CALLBACK']:
            return {
                ...state,
                callbackUrl: "",
                callbackMsg: "",
                isCallback: false
            }
            break;
        default:
            return state;
            break;
    }
};